import { useParams } from "react-router-dom";
import EnhancementSaleExpenseForm from "./EnhancementSaleExpenseForm";
import { useAuthContext } from "../../../../context/AuthContext";

const SaleExpenseForm = ({ type = "in" }) => {
  const params = useParams();
  const { business } = useAuthContext();

  return (
    <EnhancementSaleExpenseForm invoiceId={params?.id} business={business} type={type}/>
  );
};
export default SaleExpenseForm;
